import { ReactNode } from 'react';
import { cn } from '@/lib/tailwind-utils';
import { Popover, PopoverContent, PopoverAnchor } from '@/components/ui/popover';

interface CustomTableDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  title?: string;
  children?: ReactNode;
  anchor?: ReactNode;
  className?: string;
  widthClass?: string;
  collisionPadding?: number;
}

export function CustomTableDialog({
  open,
  setOpen,
  title,
  children,
  anchor,
  className,
  widthClass = 'w-auto',
  collisionPadding = 8,
}: CustomTableDialogProps) {
  return (
    <Popover open={open} onOpenChange={setOpen}>
      {anchor && <PopoverAnchor asChild>{anchor}</PopoverAnchor>}
      <PopoverContent avoidCollisions collisionPadding={collisionPadding} className={cn('p-0', widthClass, className)}>
        <div className="p-4">
          {title && <div className="text-sm font-semibold mb-2">{title}</div>}
          {children}
        </div>
      </PopoverContent>
    </Popover>
  );
}
